import React, { useState, useEffect } from 'react'
import TextField from '@mui/material/TextField';
import { BasicSelect, TextFieldChips } from './CustomSelectBox'
import { SaveRulesByData, UpdateRulesbyRuleId } from './ActionCreator';
import Popup from '../../../../presentationals/Popup/Popup.component'
import Loader from '../../../../presentationals/Loader/Loader.component'
import { Edit } from '@mui/icons-material';

const isActiveObj = [
    { name: "Yes", value: true },
    { name: "No", value: false },
];

const statusObj = [
    { name: "Complete", value: "Complete" },
    { name: "Incomplete", value: "Incomplete" },
    { name: "Repeat", value: "Repeat" },
    { name: "Operations", value: "Operations" },
    { name: "Legal", value: "Legal" },
]

const requiredFields = ["ruleId", "priority"];

export default function AddRulesPopup({ handleAddPopup, EditData }) {
    const [loader, setLoader] = useState(false)
    const [popup, setpopup] = useState({ show: false, popupStatus: {} })
    const [data, setData] = useState({
        ruleId: "",
        priority: 1,
        locationCriteria: "",
        productCriteria: "",
        pincodeCriteria: [],
        minValueCriteria: "",
        maxValueCriteria: "",
        minSalaryCriteria: "",
        maxSalaryCriteria: "",
        applicationStatus: "",
        // "targetId": ["", ""],
        isActive: true,
    })


    useEffect(() => {
        console.log("edit", EditData)
        if (EditData?.id) {
            setData({
                ruleId: EditData?.ruleId || "",
                priority: EditData?.priority ?? 1,
                locationCriteria: EditData?.locationCriteria || "",
                productCriteria: EditData?.productCriteria || "",
                pincodeCriteria: EditData?.pincodeCriteria || [],
                minValueCriteria: EditData?.minValueCriteria ?? "",
                maxValueCriteria: EditData?.maxValueCriteria ?? "",
                minSalaryCriteria: EditData?.minSalaryCriteria ?? "",
                maxSalaryCriteria: EditData?.maxSalaryCriteria ?? "",
                applicationStatus: EditData?.applicationStatus ?? "",
                isActive: EditData?.active ?? true,
            })
        } else {
            setData({
                ruleId: "",
                priority: 1,
                locationCriteria: "",
                productCriteria: "",
                pincodeCriteria: [],
                minValueCriteria: "",
                maxValueCriteria: "",
                minSalaryCriteria: "",
                maxSalaryCriteria: "",
                applicationStatus: "",
                isActive: true,
            })
        }
    }, [])

    const handleChange = (e, type) => {
        setData((prev) => ({
            ...prev,
            [type]: e.target.value,
        }));
    }

    const handleChipChange = (value, isDelete = false) => {
        if (isDelete) {
            setData((prev) => ({
                ...prev,
                pincodeCriteria: value,
            }));
        } else {
            setData((prev) => ({
                ...prev,
                pincodeCriteria: [...prev.pincodeCriteria, value],
            }));
        }
    };

    const handlebuttonDisabled = () => {
        return requiredFields.some(field => {
            const value = data[field];
            return value === null || value === undefined || value === "" || (typeof value === 'string' && value.trim() === "");
        });
    }

    const SaveRule = () => {
        if (EditData?.id) {
            const obj = {
                ...data,
                "targetId": []
            }
            setLoader(true)
            UpdateRulesbyRuleId(EditData?.id, obj, callback => {
                setLoader(false)
                console.log("ca", callback)
                if (callback && Object.keys(callback)?.includes("ruleId")) {
                    setpopup({ show: true, popupStatus: 'Rule Updated Successfully' })
                } else {
                    setpopup({ show: true, popupStatus: 'Error Updating Rule' })
                }
                removePopup()
            })

        } else {
            setLoader(true)
            SaveRulesByData(data, callback => {
                setLoader(false)
                console.log("call", callback)
                if (callback && Object.keys(callback)?.includes("ruleId")) {
                    setpopup({ show: true, popupStatus: 'Rule Created Successfully' })
                    setData({
                        ruleId: "",
                        priority: 1,
                        locationCriteria: "",
                        productCriteria: "",
                        pincodeCriteria: [],
                        minValueCriteria: "",
                        maxValueCriteria: "",
                        minSalaryCriteria: "",
                        maxSalaryCriteria: "",
                        applicationStatus: "",
                        // "targetId": ["", ""],
                        isActive: true,
                    })
                } else {
                    setpopup({ show: true, popupStatus: 'Error Creating Rule' })
                }
                removePopup()
            })
        }
    }

    const closePopup = () => {
        setpopup({ show: false, popupStatus: "" })
    }
    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    return (
        <>


            <div className="background-blur" style={{zIndex:'10'}}>

                <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px', width: '70%' }}>
                    {
                        loader ?
                            <Loader />
                            : ''
                    }



                    {
                        popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} />
                            : ''}
                    <div className="text-right" style={{ color: 'red' }}>
                        <i className="fa fa-times" style={{ cursor: 'pointer' }} onClick={() => handleAddPopup(false)}></i>
                    </div>
                    <h4><b>Add Rules</b></h4>
                    <div className="row" style={{ marginTop: '15px' }}>
                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                            <TextField fullWidth id="outlined-basic" label="Rule Name" variant="outlined"
                                sx={{
                                    ".MuiInputLabel-formControl": {
                                        background: '#fff'
                                    }
                                }}
                                type='text'
                                value={data?.ruleId}
                                onChange={(e) => handleChange(e, "ruleId")}
                            />
                        </div>
                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                            <TextField fullWidth id="outlined-basic" label="Priority" variant="outlined"
                                sx={{
                                    ".MuiInputLabel-formControl": {
                                        background: '#fff'
                                    }
                                }}
                                type='number'
                                value={data?.priority}
                                onChange={(e) => handleChange(e, "priority")}
                            />
                        </div>
                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                            <TextField fullWidth id="outlined-basic" label="Location" variant="outlined"
                                sx={{
                                    ".MuiInputLabel-formControl": {
                                        background: '#fff'
                                    }
                                }}
                                type='text'
                                value={data?.locationCriteria}
                                onChange={(e) => handleChange(e, "locationCriteria")}
                            />
                        </div>
                    </div>
                    <div className="row" style={{ marginTop: '15px' }}>
                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                            <TextField fullWidth id="outlined-basic" label="Product" variant="outlined"
                                sx={{
                                    ".MuiInputLabel-formControl": {
                                        background: '#fff'
                                    }
                                }}
                                type='text'
                                value={data?.productCriteria}
                                onChange={(e) => handleChange(e, "productCriteria")}
                            />
                        </div>

                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                            <TextField fullWidth id="outlined-basic" label="Min Value" variant="outlined"
                                sx={{
                                    ".MuiInputLabel-formControl": {
                                        background: '#fff'
                                    }
                                }}
                                type='number'
                                value={data?.minValueCriteria}
                                onChange={(e) => handleChange(e, "minValueCriteria")}
                            />
                        </div>
                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                            <TextField fullWidth id="outlined-basic" label="Max Value" variant="outlined"
                                sx={{
                                    ".MuiInputLabel-formControl": {
                                        background: '#fff'
                                    }
                                }}
                                type='number'
                                value={data?.maxValueCriteria}
                                onChange={(e) => handleChange(e, "maxValueCriteria")}
                            />
                        </div>

                    </div>
                    <div className="row" style={{ marginTop: '15px' }}>
                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                            <TextField fullWidth id="outlined-basic" label="Min Salary" variant="outlined"
                                sx={{
                                    ".MuiInputLabel-formControl": {
                                        background: '#fff'
                                    }
                                }}
                                type='number'
                                value={data?.minSalaryCriteria}
                                onChange={(e) => handleChange(e, "minSalaryCriteria")}
                            />
                        </div>
                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                            <TextField fullWidth id="outlined-basic" label="Max Salary" variant="outlined"
                                sx={{
                                    ".MuiInputLabel-formControl": {
                                        background: '#fff'
                                    }
                                }}
                                type='number'
                                value={data?.maxSalaryCriteria}
                                onChange={(e) => handleChange(e, "maxSalaryCriteria")}
                            />
                        </div>
                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                            {/* <TextField fullWidth id="outlined-basic" label="Application Status" variant="outlined"
                                sx={{
                                    ".MuiInputLabel-formControl": {
                                        background: '#fff'
                                    }
                                }}
                                type='text'
                                value={data?.applicationStatus}
                                onChange={(e) => handleChange(e, "applicationStatus")}
                            /> */}
                            <BasicSelect
                                items={statusObj}
                                SelectedValue={data?.applicationStatus}
                                Changehandler={(e) => handleChange(e, "applicationStatus")}
                                label={'Application Status'}
                            />
                        </div>
                    </div>

                    <div className="row" style={{ marginTop: '15px' }}>
                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                            <TextFieldChips
                                selectedValue={data?.pincodeCriteria}
                                type={'number'}
                                changeHandler={handleChipChange}
                                label={"Enter Pincode"}
                            />
                        </div>
                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                            <BasicSelect
                                items={isActiveObj}
                                SelectedValue={data?.isActive}
                                Changehandler={(e) => handleChange(e, "isActive")}
                                label={'Is Active'}
                            />
                        </div>
                    </div>
                    <div className="text-center" style={{ marginTop: '30px' }}>
                        <button className="btn" style={{ background: '#2B78FF', width: '100%', background: '#006c67', borderColor: '#006c67', color: '#fff', padding: '12.5px', maxWidth: '90px', marginRight: '15px' }} onClick={() => handleAddPopup(false)}>Cancel</button>
                        <button className="btn" style={{ background: '#2B78FF', width: '100%', background: '#006c67', borderColor: '#006c67', color: '#fff', padding: '12.5px', maxWidth: '90px' }} disabled={handlebuttonDisabled()} onClick={() => SaveRule()}>{EditData?.id ? "Update" : "Save"}</button>
                    </div>

                </div>
            </div>
        </>
    )
}
